import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { GenericStreamService } from '../../../../../service/generic-stream.service';
import { GenericStreamListForUserSelection, GenericStreamTag } from '../../../../../interfaces/responsedata.ts/generic-streams';

@Component({
    selector: 'app-rag-stream-reference',
    standalone: false,
    templateUrl: './rag-stream-reference.component.html',
    styleUrl: './rag-stream-reference.component.scss'
})
export class RagStreamReferenceComponent implements OnInit {
    genService = inject(GenericStreamService);
    finalAssets: any[] = [];
    genstreams: GenericStreamTag[] = [];
    selectedData: any = null;

    @Output() close = new EventEmitter<string>();
    @Output() usecontent = new EventEmitter<any>();

    ngOnInit(): void {
        this.loadData();
    }

    async loadData() {
        let genstreams = await this.genService.getGenericStreamNames();
        if (genstreams !== false) {
            this.genstreams = genstreams;
        }
        let results = await this.genService.getGenericStreamResults();
        if (results === false) {
            return;
        }

        this.finalAssets = results;
        this.finalAssets.forEach((asset) => {
            asset.active = false;
        });
    }

    findStreamNameByConfigId(id: string): string | null {
        const stream = this.genstreams.find((stream: GenericStreamTag) => stream.id === id);

        return stream ? stream.name : "Stream deprecated";
    }

    setAssetActive(index: number) {
        this.finalAssets.forEach((asset, i) => {
            asset.active = i === index;
            if (i === index) {
                this.selectedData = { name: asset.finalAsset.name, data: JSON.stringify(asset.finalAsset.data, null, 2) };
            }
        });
    }
}
